import styled from "styled-components";
import {MOBILE_HORIZONTAL_SPACE_BETWEEN_ITEMS, PC_HORIZONTAL_SPACE_BETWEEN_ITEMS} from "../space-between-items-consts";

export const PipeHorizontalSeparatorBox = styled.span`
    width: 2px;
    background-color: ${props => props.theme.colors.backgroundLight};
    height: 20px;
    margin-left: ${PC_HORIZONTAL_SPACE_BETWEEN_ITEMS()};
    margin-right: ${PC_HORIZONTAL_SPACE_BETWEEN_ITEMS()};
    @media ${props => props.theme.mediaQuery.lAndBelow} {
      height: 14px;
      margin-left: ${MOBILE_HORIZONTAL_SPACE_BETWEEN_ITEMS()};
      margin-right: ${MOBILE_HORIZONTAL_SPACE_BETWEEN_ITEMS()};
    }
`